/**
 * @fileoverview POST handler for the "/apps/:app_group_id/message_archiving_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { appsMessageArchivingSettings } from "./constants";
import type { PostMessageArchivingSettingsParams, PostMessageArchivingSettingsResponse } from "./types";

export const postMessageArchivingSettingsApiEndpoint = reactQueryMutationAdapter(
  [appsMessageArchivingSettings],
  ({
    appGroupId,
    ...payload
  }: PostMessageArchivingSettingsParams): Promise<PostMessageArchivingSettingsResponse> => {
    return fetch(`/apps/${appGroupId}/message_archiving_settings`, "POST", payload);
  }
);
